import { useEffect, useMemo, useState } from 'react'

import { breakpoints } from '../constants'
import { BreakpointName } from '../utils/media-queries'

const sortedBreakpoints = Object.entries(breakpoints).sort(
  ([_aKey, aValue], [_bKey, bValue]) => bValue - aValue,
) as [BreakpointName, number][]

type Breakpoints = {
  current: BreakpointName | undefined
  eq: Record<BreakpointName, boolean>
  gte: Record<BreakpointName, boolean>
  lt: Record<BreakpointName, boolean>
}

const getCurrentBreakpoint = () => {
  if (typeof window === 'undefined') {
    return undefined
  }

  for (const [name, value] of sortedBreakpoints) {
    if (value <= window.innerWidth) {
      return name
    }
  }
}

export const useBreakpoint = (): Breakpoints => {
  const [current, setCurrent] = useState(getCurrentBreakpoint())

  useEffect(() => {
    const handler = () => {
      setCurrent(getCurrentBreakpoint())
    }

    window.addEventListener('resize', handler)

    return () => {
      window.removeEventListener('resize', handler)
    }
  }, [])

  return useMemo(
    () => ({
      current,
      eq: {
        sm: current === 'sm',
        md: current === 'md',
      },
      gte: {
        sm: current === 'sm' || current === 'md',
        md: current === 'md',
      },
      lt: {
        sm: false,
        md: current === 'sm',
      },
    }),
    [current],
  )
}
